import { collectPagedResource } from '../httpHelpers/primer';
import { QualificationData } from './types';
import { Assessment } from '../../types/Syllabuses';

export const getQualificationsResponse = (businessUnitId: string): Promise<QualificationData> =>
  collectPagedResource(`v1/businessUnit/${businessUnitId}/qualifications`);

export const getAssessmentVersionsResponse = (
  businessUnitId: string,
  qualificationId: number,
  assessmentCode: string,
): Promise<Assessment[]> =>
  collectPagedResource(
    `v1/businessUnit/${businessUnitId}/qualifications/${qualificationId}/assessments/${assessmentCode}/versions`,
  );
